var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 31,
    viewBox: "0 0 16 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.302734 10.7122H3.55475V7.69536C3.55475 6.27568 3.55474 4.32362 4.63875 3.0814C5.72275 1.66171 7.16809 0.774414 9.51676 0.774414C13.4914 0.774414 15.2981 1.30679 15.2981 1.30679L14.5754 5.92076C14.5754 5.92076 13.3108 5.56584 12.0461 5.56584C10.7814 5.56584 9.69743 5.92076 9.69743 7.16298V10.7122H14.7561L14.3948 15.1487H9.69743V30.7652H3.73541V15.1487H0.483402V10.7122H0.302734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.6339669596924895824246207c8a4440.svg";
export { ForwardRef as ReactComponent };